$(document).ready( function() {
   function getDVCartAtr(){
    $.ajax({
          url: '/cart.js',
          type: 'GET',
          dataType: 'json',
          success: function(results) {
            if ( results.attributes['desktop-view'] ) {
            	$("meta[name=viewport]").attr("content", "width=1270px,initial-scale=0");
              	$('.mobile-view').show();
              	$('.desktop-view').hide();
            } else {
            	$("meta[name=viewport]").attr("content", "width=device-width,initial-scale=1");
            }
          }
        });
    }

   getDVCartAtr();

    $('.mobile-view').on('click', function(e) {
        e.preventDefault();
        $("meta[name=viewport]").attr("content", "width=device-width,initial-scale=1");

        $('.desktop-view').show();
        $('.mobile-view').hide();

         function setDVCartAtr(){
          $.ajax({
                url: '/cart/update',
                type: 'POST',
                dataType: 'json',
                data: {
                  attributes: {
                    'desktop-view': ''
                  }
                }
              });
          }
         setDVCartAtr();

    });


    $('input.header-bar__search-input').on('focus click', function() {
        $(this).val('');
    });

    setTimeout(function() {
        $('.chat-btn').find('img').attr('src','//cdn.shopify.com/s/files/1/1552/7691/t/22/assets/chat-icon.png?17921631088215952881');
    }, 400);

    //move .color-variant function to product.liquid to avoid conflict with quick view color-variant

    $('.size-variant').find('li.li-size').on('mouseenter',function() {
      var liSizeVal = $(this).data('size');
      if(liSizeVal){
        $('.size-hover').text(liSizeVal);

        if (  $('.size-hover').text().indexOf('/') > -1 ) {
          var splitSZ = $('.size-hover').text().split('/');
          var splitTwoFirstLetterSZ = splitSZ[1].substring(1,0).toUpperCase();
          var splitRemainingLetterSZ = splitSZ[1].substring(1);

          $('.size-hover').text( splitSZ[0] + "/" + splitTwoFirstLetterSZ + splitRemainingLetterSZ );
        }
      }
    }).on('mouseleave', function() {
      var productSize = $('.size-hover').data('size');
      $('.size-hover').text(productSize);
      if (  $('.size-hover').text().indexOf('/') > -1 ) {
        var splitSZ = $('.size-hover').text().split('/');
        var splitTwoFirstLetterSZ = splitSZ[1].substring(1,0).toUpperCase();
        var splitRemainingLetterSZ = splitSZ[1].substring(1);

        $('.size-hover').text( splitSZ[0] + "/" + splitTwoFirstLetterSZ + splitRemainingLetterSZ );
      }

    });

// filter-group-collections

    if ( $('.filter-menu').find('.filter-group:not(.filter-group-not-shown)').find('.collection-container').hasClass('selected') ) {
      	$('.sidebar-module__list').find('li').hide();
      	$('.sidebar-sublist').removeClass('is-open');
    } else {
    	$('.sidebar-module__list').find('li').css('display','list-item');
    }


    $(document).on('click', '.quick-view-btn', function() {
        var quickviewSRC = $('.mfp-wrap').find('#ProductPhotoImg').data('imgsrc');
        $('.mfp-wrap').find('#ProductPhotoImg').attr('src', quickviewSRC);

        if ( $('.mfp-wrap').length > 0 ) {
            $('.mfp-wrap').find('ul.product-single__thumbnail').find('li').each(function() {
                var thumbnailSrc = $(this).data('thsource');

                $(this).find('img').attr('src', thumbnailSrc);

            });
        } else {
          setTimeout(function() {
            $('.mfp-wrap').find('ul.product-single__thumbnail').find('li').each(function() {
                var thumbnailSrc = $(this).data('thsource');

                $(this).find('img').attr('src', thumbnailSrc);

            });

          }, 500);

        }
    });


  if ($('.rpw-vertical').length > 0 ) {

      var theVerticalHeight = 0;
      setTimeout(function() {
        var theCounter = 0;
          $.each( $('.rpw-vertical').find('.isp_related_product'), function() {
            if (theCounter <= 3) {
                theVerticalHeight += ($(this).height() + 6);
            	theCounter++;
            }

          });
          $('.rpw-vertical').find('.isp_related_products').wrap('<div class="new-rp-wrapper"></div>').css('position','absolute');
          //$('.new-rp-wrapper').css('height',theVerticalHeight+'px'); //remove this line to make related products height auto
      }, 1000);



    $('#arrowUp').on('click', function() {
      $('.rpw-vertical').find('.isp_related_products').css({'bottom': 0, 'top':'initial'});

    });

    $('#arrowDown').on('click', function() {
      $('.rpw-vertical').find('.isp_related_products').css({'top': 0, 'bottom':'initial'});
    });
  }

  $('#nav-toggle').on('click', function() {
    $('.bold-collection-filters').toggle();
  });

});
